/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = rest;
  const { token, isAuthenticated, accessToken } = user;

  const checkPermission = () => {
    return Boolean(isAuthenticated);
  };

  if (checkPermission()) {
    return <Route {...rest} render={props => <Component {...props} accessToken={accessToken} idToken={token} />} />;
  }

  return <Redirect to={`/login/?${rest.location.pathname}`} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(PrivateRoute);
